import getUuidByString from 'uuid-by-string';
export function removeDashes(str) {
    if (!str)
        return str;
    return str.replace(/-/g, '');
}
export const genUuid = (str) => {
    if (Array.isArray(str)) {
        str = str.join('-');
    }
    return removeDashes(getUuidByString(str));
};
// inverse of removeDashes for pg uuid cols (pg accepts both forms; no-dash input gets hyphenated)
export const toDashedUuid = (id) => /^[0-9a-f]{32}$/.test(id) ? `${id.slice(0, 8)}-${id.slice(8, 12)}-${id.slice(12, 16)}-${id.slice(16, 20)}-${id.slice(20)}` : id;
